import _directionDownLine from "@zenlayer/zen-design-icons/assets/direction/DownLine.svg";
import _directionUpLine from "@zenlayer/zen-design-icons/assets/direction/UpLine.svg";
import { useControllableValue } from 'ahooks';
import classNames from 'classnames';
import { pickDomAttrs } from '../_util/utils';
import Icon from '../icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TypographyCollapse = props => {
  const {
    title,
    gap,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-typography-collapse");
  const attrs = pickDomAttrs(restProps);
  const [visible, setVisible] = useControllableValue(props, {
    defaultValue: false,
    defaultValuePropName: 'defaultOpened',
    valuePropName: 'opened',
    trigger: 'onOpenedChange'
  });
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    className: classNames(baseClassName, className),
    style: style,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "-header"),
      onClick: () => {
        setVisible(v => !v);
      },
      children: [/*#__PURE__*/_jsx("div", {
        children: title
      }), /*#__PURE__*/_jsx("span", {
        className: "collapse-icon",
        children: visible ? /*#__PURE__*/_jsx(Icon, {
          type: "direction/UpLine",
          block: true
        }) : /*#__PURE__*/_jsx(Icon, {
          type: "direction/DownLine",
          block: true
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: classNames("".concat(baseClassName, "-body"), {
        visible
      }),
      style: {
        marginTop: gap
      },
      children: children
    })]
  });
};
export default TypographyCollapse;